import instanceQuery from 'graphql/queries/nominal/NominalJournalPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const NominalJournalPostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default NominalJournalPostingPreview;
